"use client";

import { Container, Stack, Typography } from "@mui/material";
import CategoriesSlider, { ItemType } from "../CategoriesSlider";
import BentoSection from "./BentoSection";
import ProductWithCategoryFilterSection from "./ProductWithCategoryFilterSection";
import BannerCarousel from "./BannerCarousel";
import ProductSpecialOffersSection from "./ProductSpecialOffersSection";
import { banners } from "./DesktopBanners";
import BestSellingProductsSection from "./BestSellingProductsSection";
import InterestingCategoryProductsSection from "./InterestingCategoryProductsSection";
import PageWrapper from "@/app/_components/PageWrapper";

type Props = {
  shuffledItems: ItemType[];
  items: ItemType[];
  interestingCategoriesCarousel: ItemType[];
  title: string;
  /** @deprecated Layout is CSS-breakpoint driven; kept optional for call-site compat */
  isMobile?: boolean;
};

export default function MainPageClient({ shuffledItems, items, title, interestingCategoriesCarousel }: Props) {
  return (
    <>
      <PageWrapper
        sx={{
          mt: 2,
        }}
      >
        <Typography component={"h1"} className="visually-hidden">
          {title}
        </Typography>
        <Stack sx={{ display: { xs: "flex", md: "none" } }}>
          <Typography>
            <b>دسته بندی</b> محصولات
          </Typography>
          <CategoriesSlider items={items as any} />
        </Stack>
        <BentoSection />
        <Stack spacing={5} mt={5}>
          <ProductWithCategoryFilterSection items={shuffledItems} />
          <Stack sx={{ display: { xs: "flex", md: "none" } }}>
            <BannerCarousel banners={banners} />
          </Stack>
          <Stack sx={{ display: { xs: "none", md: "flex" } }}>{banners[0]}</Stack>
          <ProductSpecialOffersSection catId={(shuffledItems && shuffledItems.length > 0 && shuffledItems[0].id) || 0} />
          <Stack direction={"row"} spacing={2} sx={{ display: { xs: "none", md: "flex" } }}>
            {banners[1]}
            {banners[2]}
          </Stack>
          <BestSellingProductsSection catId={(shuffledItems && shuffledItems.length > 0 && shuffledItems[0].id) || 0} />
          {interestingCategoriesCarousel.map((a, index) => {
            return (
              <InterestingCategoryProductsSection
                key={a.href + index}
                catId={a.id}
                href={a.href}
                title={a.title}
                svg={a.svg}
                bgColor={a.bgColor}
                image={a.image}
              />
            );
          })}
        </Stack>
      </PageWrapper>
    </>
  );
}
